import React, { useContext } from 'react';

const AppContext = React.createContext({
    displayBrandCampaign: false,
    inDolphinsTofRedirect: false,
    withEnglishBAL: false,
    inCheetahsBookPublishing: false,
});

export const useAppContext = () => useContext(AppContext);

export default AppContext;
